import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    FullParamMapResolver,
    ModalContainer
} from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { GeneralTaskDetailsDialogueComponent } from '../general-task-details-dialogue/general-task-details-dialogue.component';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                children: [
                    {
                        path: ':taskId',
                        component: ModalContainer,
                        data: {
                            modalContent: GeneralTaskDetailsDialogueComponent,
                            modalClass: 'modal-lg',
                            relativeRoute: '../../'
                        },
                        resolve: {
                            initialState: FullParamMapResolver
                        },
                        children: [
                            {
                                path: 'edit',
                                component: ModalContainer,
                                data: {
                                    modalContent:
                                        GeneralTaskDetailsDialogueComponent,
                                    modalClass: 'modal-lg',
                                    relativeRoute: '../'
                                },
                                resolve: {
                                    initialState: FullParamMapResolver
                                }
                            }
                        ]
                    }
                    /* {
                        path: ':taskId/edit',
                        component: ModalContainer,
                        data: {
                            modalContent: GeneralTaskDetailsDialogueComponent,
                            modalClass: 'modal-lg',
                            relativeRoute: '../../../'
                        },
                        resolve: {
                            initialState: FullParamMapResolver
                        }
                    } */
                    /* {
                        path: 'bulk',
                        component: ModalContainer,
                        data: {
                            modalContent: MaintenanceDetailsDialogue,
                            modalClass: 'modal-lg',
                            relativeRoute: '../../'
                        },
                        resolve: {
                            initialState: FullParamMapResolver
                        }
                    },

                    {
                        path: 'edit/:maintenanceLogId',
                        component: ModalContainer,
                        data: {
                            modalContent: MaintenanceDetailsDialogue,
                            modalClass: 'modal-lg',
                            relativeRoute: '../../../'
                        },
                        resolve: {
                            initialState: FullParamMapResolver
                        }
                    } */
                ]
            }
        ])
    ],
    exports: [RouterModule]
})
export class GeneralTasksRoutingModule {}
